
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChevronRightGoogle as ObiChevronRightGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chevron-right-google.js';
 
 
 

 
 export const ObiChevronRightGoogle = createComponent({
   react: React,
   tagName: 'obi-chevron-right-google',
   elementClass: ObiChevronRightGoogleElement,
   events: {
     
   }
  });
 
 